import { h } from 'preact';
import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/Inspection/inspection.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let Inspection = loaded.default;
        return <Inspection {...props} />;
    }
});



// WEBPACK FOOTER //
// ../q-cars/src/containers/Inspection/index.js